import React, { useState } from "react";
import { customColors } from "../util/Theme";
import { InVisCanvas } from "../invis/InVisCanvas";
import { InVisControls } from "../invis/InVisControls";
import { useInVisEngine } from "../invis/useInVisEngine";

export const InVisDemoSite = () => {
  const {
    data,
    state,
    controlPoints,
    loading,
    error,
    renderTick,
    kernel,
    dataset,
    setKernel,
    setDataset,
    addControlPoint,
    moveControlPoint,
    toggleControlPoint,
    finishDragging,
    resetAll,
  } = useInVisEngine();

  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  if (error) {
    return (
      <div style={{ padding: 40, fontFamily: "'Figtree', sans-serif" }}>
        <h2>Error loading demo</h2>
        <p>{error}</p>
      </div>
    );
  }

  const labelMin = data ? Math.min(...data.labels) : 0;
  const labelMax = data ? Math.max(...data.labels) : 1;

  return (
    <div
      style={{
        height: "calc(100vh - 66px)",
        position: "relative",
        background: "#fafafa",
        overflow: "hidden",
      }}
    >
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "'Figtree', sans-serif",
            fontSize: 16,
            color: "#666",
          }}
        >
          Loading dataset...
        </div>
      )}
      {data && (
        <>
          <InVisCanvas
            data={data}
            state={state}
            controlPoints={controlPoints}
            renderTick={renderTick}
            onToggleControlPoint={toggleControlPoint}
            onMoveControlPoint={moveControlPoint}
            onAddControlPoint={addControlPoint}
            onFinishDragging={finishDragging}
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
          />
          <InVisControls
            onReset={resetAll}
            labelMin={labelMin}
            labelMax={labelMax}
            kernel={kernel}
            dataset={dataset}
            onKernelChange={setKernel}
            onDatasetChange={setDataset}
          />
          {/* Title overlay - top left */}
          <div
            style={{
              position: "absolute",
              top: 14,
              left: 18,
              fontFamily: "'Figtree', sans-serif",
              fontSize: 24,
              fontWeight: 700,
              color: customColors.foreground,
              pointerEvents: "none",
              zIndex: 5,
            }}
          >
            InVis: Interactive Data Visualization
          </div>
          {/* Algorithm note - bottom center */}
          <div
            style={{
              position: "absolute",
              bottom: 18,
              left: "50%",
              transform: "translateX(-50%)",
              fontFamily: "'Figtree', sans-serif",
              fontSize: 13,
              fontWeight: 400,
              color: customColors.foreground,
              opacity: 0.5,
              pointerEvents: "none",
              zIndex: 5,
            }}
          >
            Currently using iterative Interactive Kernel PCA
          </div>
        </>
      )}
    </div>
  );
};
